module.exports = __webpack_public_path__ + "img/ok.69bf2b20.png";